import React from 'react';
import { XbpmContext } from '@unitarius/xbpm-runtime';
import { IframeBridge } from './IframeBridge';
export class IframeBridgeHost extends React.PureComponent {
    constructor(props) {
        super(props);
        this.openModalHandler = (id, params) => {
            this.setState({ instances: [...this.state.instances, { id, params }] });
            // disable scroll
            document.body.style.overflow = 'hidden';
            return {
                hide: () => this.setState(state => ({
                    instances: state.instances.filter(it => it.id !== id)
                }), () => {
                    if (this.state.instances.length === 0) {
                        // enable scroll
                        document.body.style.overflow = '';
                    }
                })
            };
        };
        this.state = { instances: [] };
        this.bridgeHostService = XbpmContext.getContext().getProvider('bridgeHostService');
        this.bridgeHostService.setOpenModalHandler(this.openModalHandler);
    }
    render() {
        const { instances } = this.state;
        return (!instances.length ? null
            : React.createElement("div", { className: 'iframe-bridge-host' }, instances.map(({ id, params }, i) => React.createElement(IframeBridge, { key: id, id: id, src: params.url || this.bridgeHostService.getInstanceUrl(id, params), display: i === instances.length - 1 }))));
    }
}
//# sourceMappingURL=IframeBridgeHost.js.map